import { call, put, takeEvery } from 'redux-saga/effects'
import { getTransaction, getTransactionPDF,getListTransactionAdmin } from '../apiRequests/transactionRequest'
import { types } from '../../types'

function* handleGetTransaction(action) {
  try {
    const response = yield call(getTransaction, action.params, action.userId);

    yield put({
      type: types.TRANSACTION_LIST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.TRANSACTION_LIST_ERROR,
      action: error,
    })
  }
}

function* handleGetTransactionPDF(action) {
  try {
    const response = yield call(getTransactionPDF, action.params);

    yield put({
      type: types.TRANSACTION_PDF_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.TRANSACTION_PDF_ERROR,
      action: error,
    })
  }
}

function* handleGetListTransactionAdmin(action) {
  try {
    const response = yield call(getListTransactionAdmin, action.params);

    yield put({
      type: types.TRANSACTION_LIST_ADMIN_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.TRANSACTION_LIST_ADMIN_ERROR,
      action: error,
    })
  }
}

function* watcherTransactionSaga() {
  yield takeEvery(types.TRANSACTION_LIST_REQUEST, handleGetTransaction)
  yield takeEvery(types.TRANSACTION_PDF_REQUEST, handleGetTransactionPDF)
  yield takeEvery(types.TRANSACTION_LIST_ADMIN_REQUEST, handleGetListTransactionAdmin)

}

export default watcherTransactionSaga
